import type { BadgeProps } from '../types'

import { textVariants } from '#components/text/styles'
import { TextColor, TextSize } from '#components/text/types'
import { cn } from '#lib/cn'

import { badgeVariants, sectionSizeClasses } from '../_shared/styles'

export { badgeVariants }

export function Badge({
  leftSection,
  rightSection,
  children,
  variant,
  truncate,
  className,
  ref,
  ...props
}: BadgeProps) {
  return (
    <span
      className={cn(badgeVariants({ variant }), className)}
      ref={ref}
      {...props}
    >
      {leftSection && (
        <span className={sectionSizeClasses} data-section="left">
          {leftSection}
        </span>
      )}
      {children && (
        <span
          className={cn(
            textVariants({
              color: TextColor.Inherit,
              size: TextSize.XS,
            }),
            truncate && 'min-w-0 truncate',
          )}
          data-label=""
        >
          {children}
        </span>
      )}
      {rightSection && (
        <span className={sectionSizeClasses} data-section="right">
          {rightSection}
        </span>
      )}
    </span>
  )
}

Badge.displayName = 'Badge'
